import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
var ErrorBanner = function () {
    return (React.createElement("div", { className: "sui-mt-6 md:sui-mt-0 md:sui-max-w-3xl", "data-testid": "error-banner" },
        React.createElement(Alert, { status: "error", size: "large" },
            React.createElement(Typography, { variant: "body-base" }, "We\u2019re sorry. There was a temporary technical error. Please try again shortly."))));
};
export default ErrorBanner;
